/**
 * useDebugMode — reaktivně sleduje per-zařízení debug flag (localStorage), reaguje
 * na přepnutí v této i jiné záložce. Viz `debug-mode.ts`.
 */
import { useSyncExternalStore } from "react";
import { DEBUG_CHANGED_EVENT, isDebugMode, isDebugHidden } from "./debug-mode.js";

function subscribe(cb: () => void): () => void {
  window.addEventListener(DEBUG_CHANGED_EVENT, cb);
  window.addEventListener("storage", cb);
  return () => {
    window.removeEventListener(DEBUG_CHANGED_EVENT, cb);
    window.removeEventListener("storage", cb);
  };
}

export function useDebugMode(): boolean {
  return useSyncExternalStore(subscribe, isDebugMode, () => false);
}

/** Reaktivně sleduje, zda je bug ikona natrvalo skrytá z menu. */
export function useDebugHidden(): boolean {
  return useSyncExternalStore(subscribe, isDebugHidden, () => false);
}
